import { RefObject, useLayoutEffect } from 'react';

const publish = (cssVarName: string, element: HTMLElement) =>
  document.documentElement.style.setProperty(
    cssVarName,
    `${element.getBoundingClientRect().height}px`
  );

export const usePublishedHeight = (
  elementRef: RefObject<HTMLElement | null>,
  cssVarName: string,
  isShown: boolean
) => {
  useLayoutEffect(() => {
    const element = elementRef.current;
    if (!isShown || !element) return;

    publish(cssVarName, element);
    const observer = new ResizeObserver(() => publish(cssVarName, element));
    observer.observe(element);

    return () => {
      observer.disconnect();
      document.documentElement.style.removeProperty(cssVarName);
    };
  }, [elementRef, cssVarName, isShown]);
};
